import { Tabs, TabsProps } from 'antd';

/**
 * ScTabs - Wrapper cho antd 6 Tabs
 * Tương thích props của antd Tabs, kèm sub-component TabPane
 */
const ScTabs: React.FC<TabsProps> & {
    TabPane: typeof Tabs.TabPane;
} = (props) => <Tabs {...props} />;

ScTabs.TabPane = Tabs.TabPane;
ScTabs.displayName = 'ScTabs';

export default ScTabs;
